<template>
    <div class="home">
        <b-container fluid>
            <h1>{{$keycloak.fullName ? ($keycloak.fullName + ($keycloak.fullName.charAt($keycloak.fullName.length - 1) == "s" ? "'" : "'s") + " ") : ""}}Dashboard</h1>

            <p>The Minnesota Department of Health (MDH) is required to collect data from health plan companies regarding their membership,
                revenues, and expenditures for Minnesota residents, under <a href="https://www.revisor.mn.gov/statutes/?id=62J.38" target="_blank">Minnesota Statutes 62J.38</a>, <a href="https://www.revisor.mn.gov/statutes/?id=62J.321" target="_blank">Minnesota Statutes 62J.321</a>, and <a href="https://www.revisor.mn.gov/rules/?id=4652" target="_blank">Minnesota Rules,
                chapter 4652</a>. As part of this data collection, MDH requires all health plan
                companies to submit aggregated data regarding their business to the department, with filings due April 1
                for the prior calendar year.</p>
          <p>This portal will give you the opportunity to update your company demographics and contact information. Then your completed <a href="https://www.health.state.mn.us/data/economics/hccis/reporting/healthplan/index.html" target="_blank">HPFSR</a> file can be submitted via upload. Please review the User Tips found at the top of your screen for helpful information.
            </p>
            <b-button variant="primary" to="search">Continue</b-button>

        </b-container>

    </div>
</template>

<script>
import lambdaURL from '../lambda'

    export default {
        mounted() {
            lambdaURL.pingEndpoint();
        }
    }
</script>

<style>
    .hasError label {
        color: #d20000;
    }
</style>
